import { useContext } from 'react';
import InitialApplicationContext from 'Support/Contexts/InitialApplicationContext';

export default () => useContext(InitialApplicationContext);
